/** Legacy path. The primitive lives in `@/components/ui/button` (DESIGN.md §6). */
export { Button, buttonClasses, buttonVariants, resolveButtonVariant } from '@/components/ui/button';

export type { ButtonProps, ButtonSize, ButtonVariant, LegacyButtonVariant } from '@/components/ui/button';
